"use client";
import { Fab, useTheme } from "@mui/material";
import { useState } from "react";
import CourseBottomSheet from "./CourseBottomSheet";

interface CourseFABProps {
  catalog: any[];
}

/**
 * 课程目录 FAB 按钮组件
 * 在移动端显示浮动按钮，点击后弹出底部抽屉显示课程目录
 */
export default function CourseFAB({ catalog }: CourseFABProps) {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      {/* 浮动操作按钮 */}
      <Fab
        size="small"
        onClick={handleOpen}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1200,
          display: { xs: "flex", md: "none" }, // 只在移动端显示
          bgcolor: theme.palette.mode === "dark" ? "#F2F2F2" : "#2D3135",
          width: 48,
          height: 48,
          minHeight: 48,
          "&:hover": {
            bgcolor: theme.palette.mode === "dark" ? "#F2F2F2" : "#2D3135", // 保持与默认背景色相同
          },
        }}>
        <BookIcon color={theme.palette.mode === "dark" ? "#161A1E" : "#F2F2F2"} />
      </Fab>

      {/* 课程目录底部弹出组件 */}
      <CourseBottomSheet 
        catalog={catalog} 
        open={isOpen} 
        onClose={handleClose}
      />
    </>
  );
}

function BookIcon({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 7V21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3 18C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18H15C14.2044 18 13.4413 18.3161 12.8787 18.8787C12.3161 19.4413 12 20.2044 12 21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H3Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
